// Pictograms ship with the iframe (public/amenity-icons, a copy of the backend's
// public/images/amenities): CSS masks load images in CORS mode, so icons from the
// tenant domain would be blocked on the iframe domain.
export const amenityIconUrl = (icon) =>
  `${process.env.PUBLIC_URL || ""}/amenity-icons/${icon}.svg`;

export const amenityLabelKey = (code) => `amenity.items.${code}`;

// Readable fallback while translations are missing, e.g. "hair_dryer" -> "Hair dryer".
export const amenityFallbackLabel = (code) => {
  const text = String(code || "").replace(/_/g, " ");

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const validAmenities = (amenities) =>
  (Array.isArray(amenities) ? amenities : []).filter(
    (amenity) => amenity && amenity.code && amenity.icon
  );

export const visibleAmenities = (amenities, expanded, limit) =>
  expanded || amenities.length <= limit ? amenities : amenities.slice(0, limit);

export const hasHiddenAmenities = (amenities, limit) => amenities.length > limit;

// Max occupancy of a single apartment; aparthotels show it per apartment instead.
export const propertyMaxOccupancy = (property) => {
  if (!property || property.property_type === "apart_hotel") {
    return null;
  }
  const value = Number(property.rooms?.maxOccupancy);

  return Number.isFinite(value) && value > 0 ? value : null;
};
